import * as React from 'react';
import { memo } from 'react';

const SvgClockCounterClockwise = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.218 6.028v3.15M11.948 10.754l-2.73-1.575M5.53 7.321H2.905V4.696", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.137 13.26a5.775 5.775 0 1 0 0-8.164L2.905 7.321", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgClockCounterClockwise);

export { Memo as default };
